<app-deliverables-view-route
  [displayedColumns]="displayedColumns"
  [nodeId]="nodeId$ | async"
></app-deliverables-view-route>
